
import { makeStyles, createStyles, Theme} from "@material-ui/core";
import { WHITE, PRIMARY_RED, GRAY} from "../../../const/colors";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container:{
            justifyContent: 'flex-end',
            alignItems:'center',
            backgroundColor: WHITE,
            paddingTop:16,
            [theme.breakpoints.up('md')]: {
                paddingTop: 24,
            }
            
        },
        buttonSelected:{
            backgroundColor: WHITE,
            borderColor: PRIMARY_RED,
            border: '1px solid',
            minWidth:'83px',
            height:'40px',
            borderRadius:3,
            fontSize:16,
            color:PRIMARY_RED,
            marginRight:24
        },
        button:{
            backgroundColor: WHITE,
            borderColor: GRAY,
            border: '1px solid',
            minWidth:'83px',
            height:'40px',
            borderRadius:3,
            fontSize:16,
            color:GRAY,
            marginRight:24
        },
        editIcon:{
            height: 20,
            width: 20,
        }
        
    }),
);

export default useStyles;
